class FlipCountdown {
  constructor() {
    this.hoursElement = document.querySelector('.flip-countdown-hours');
    this.minutesElement = document.querySelector('.flip-countdown-minutes');
    this.secondsElement = document.querySelector('.flip-countdown-seconds');
    this.interval = null;
    this.endTime = this.getEndOfDay();
  }

  getEndOfDay() {
    const endOfDay = new Date();
    endOfDay.setHours(24, 0, 0, 0);
    return endOfDay;
  }

  calculateTimeUnits(timeLeft) {
    const hours = Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    return { hours, minutes, seconds };
  }

  start() {
    if (this.interval) this.clear();
    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  clear() {
    clearInterval(this.interval);
    this.interval = null;
    this.endTime = this.getEndOfDay();
  }

  update() {
    const timeLeft = this.endTime - Date.now();

    if (timeLeft <= 0) {
      this.clear();
      this.start();
      return;
    }

    const { hours, minutes, seconds } = this.calculateTimeUnits(timeLeft);

    this.updateElement(this.hoursElement, hours);
    this.updateElement(this.minutesElement, minutes);
    this.updateElement(this.secondsElement, seconds);
  }

  updateElement(element, value) {
    const tens = Math.floor(value / 10);
    const ones = value % 10;

    const tensElement = element.querySelector('[data-js="counter-two-degits"]');
    const onesElement = element.querySelector('[data-js="counter-one-degits"]');

    this.updateNumber(tensElement, tens);
    this.updateNumber(onesElement, ones);
  }

  updateNumber(element, value) {
    const current = element.querySelector('[data-js="counting"]');

    if (current.textContent == value.toString()) return;

    element.classList.add('active');
    element.classList.remove('flip');

    const timeout = setTimeout(() => {
      current.textContent = value;
      element.classList.remove('active');
      element.classList.add('flip');
      clearTimeout(timeout);
    }, 500);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const countdown = new FlipCountdown();
  countdown.start();
});
